export enum TimespanEnum {
  Thirty = 30,
  Sixty = 60,
  Ninety = 90,
}

export type TimeSpanOption = {
  label: string;
  value: string;
};
